import React, { useState } from 'react';
import './Contact.css';

const channels = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
        <polyline points="22,6 12,13 2,6"/>
      </svg>
    ),
    label: 'Email HQ',
    value: 'operations@blueclan.tech',
    sub: 'Response within 2 hours',
    color: '#00d4ff',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
        <circle cx="12" cy="10" r="3"/>
      </svg>
    ),
    label: 'Global HQ',
    value: 'India · USA · UK',
    sub: 'Remote-first, worldwide ops',
    color: '#7b2fff',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.69h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l.81-.81a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
      </svg>
    ),
    label: 'War Room',
    value: '+91 98765 43210',
    sub: 'Mon–Fri, 9 AM–8 PM IST',
    color: '#ffd700',
  },
];

const services = ['AI Development', 'Web Development', 'App Development', 'UI/UX Design', 'Cloud Architecture', 'Other'];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', service: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = e => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 5000);
    setForm({ name: '', email: '', service: '', message: '' });
  };

  return (
    <section className="contact section" id="contact">
      <div className="grid-bg" />
      <div className="contact-orb contact-orb-1" />
      <div className="contact-orb contact-orb-2" />

      <div className="container">
        <div className="section-header" style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto 60px' }}>
          <span className="section-tag" style={{ justifyContent: 'center' }}>Start A Mission</span>
          <h2 className="section-title" style={{ textAlign: 'center' }}>
            INITIATE <span className="gradient-text">CONTACT</span>
          </h2>
          <p className="section-desc" style={{ textAlign: 'center', marginTop: '16px' }}>
            Whether it's a stealth startup or enterprise assault — tell us your objective
            and we'll deploy the right firepower.
          </p>
        </div>

        <div className="contact-grid">
          {/* Form */}
          <div className="contact-form-wrap glass-card">
            <div className="form-header">
              <span className="form-tag">// Mission Brief</span>
            </div>

            {sent ? (
              <div className="form-success">
                <div className="success-icon">✓</div>
                <h3>Message Received, Commander</h3>
                <p>Our team will respond within 2 hours. Stand by.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Your Name</label>
                    <input
                      className="form-input"
                      type="text"
                      name="name"
                      placeholder="Commander Name"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Email Address</label>
                    <input
                      className="form-input"
                      type="email"
                      name="email"
                      placeholder="you@domain.com"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Service Required</label>
                  <select
                    className="form-input form-select"
                    name="service"
                    value={form.service}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Operation Type</option>
                    {services.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label">Mission Brief</label>
                  <textarea
                    className="form-input form-textarea"
                    name="message"
                    placeholder="Describe your project, goals, timeline, and budget..."
                    value={form.message}
                    onChange={handleChange}
                    required
                    rows={5}
                  />
                </div>

                <button type="submit" className="btn-primary form-submit">
                  <span>Launch Mission</span>
                </button>
              </form>
            )}
          </div>

          {/* Channels */}
          <div className="contact-right">
            <div className="channels">
              {channels.map(c => (
                <div className="channel-card glass-card" key={c.label} style={{ '--channel-color': c.color }}>
                  <div className="channel-icon" style={{ color: c.color, background: `${c.color}15`, borderColor: `${c.color}30` }}>
                    {c.icon}
                  </div>
                  <div className="channel-info">
                    <div className="channel-label">{c.label}</div>
                    <div className="channel-value">{c.value}</div>
                    <div className="channel-sub">{c.sub}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* response promise */}
            <div className="response-card glass-card">
              <div className="response-header">
                <span className="r-dot" /><span>SLA Guarantee</span>
              </div>
              <div className="response-items">
                {[
                  ['Initial Response', '< 2 hours'],
                  ['Project Proposal', '< 24 hours'],
                  ['Kickoff Meeting', '< 48 hours'],
                ].map(([label, val]) => (
                  <div className="response-row" key={label}>
                    <span className="r-label">{label}</span>
                    <span className="r-val">{val}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Social links */}
            <div className="social-strip glass-card">
              <span className="social-strip-label">Follow the Clan</span>
              <div className="social-icons">
                {[
                  { name: 'GitHub',   href: '#', icon: 'GH' },
                  { name: 'LinkedIn', href: '#', icon: 'LI' },
                  { name: 'Twitter',  href: '#', icon: 'TW' },
                  { name: 'Discord',  href: '#', icon: 'DC' },
                ].map(s => (
                  <a key={s.name} href={s.href} className="social-icon-btn" aria-label={s.name}>
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
